var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.973,
    viewBox: "0 0 18 17.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trace_-_2024-05-17T184904.808",
    "data-name": "trace - 2024-05-17T184904.808",
    transform: "translate(0 0.059)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41313",
    "data-name": "Path 41313",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41314",
    "data-name": "Path 41314",
    d: "M3.835,0A4.6,4.6,0,0,0,.574,2.423,4.459,4.459,0,0,0,.21,3.4L.116,3.75.105,8.767c-.012,5.516-.017,5.345.2,6.013a4.557,4.557,0,0,0,3.561,3.073c.5.081,9.831.081,10.33,0a4.531,4.531,0,0,0,3.684-3.577,2.682,2.682,0,0,1,.09-.377c.044-.088.04-10,0-9.974-.019.012-.035-.014-.035-.059a4.7,4.7,0,0,0-.53-1.6A4.49,4.49,0,0,0,14.144-.008C13.731-.081,4.272-.074,3.835,0M8.348,3.4a5.488,5.488,0,0,0-3.5,2.009A5.252,5.252,0,0,0,3.692,8.4a5.388,5.388,0,0,0,.558,2.827l.2.388-.483,1.416c-.265.779-.478,1.426-.473,1.439s.614-.171,1.353-.408c1.8-.578,1.607-.538,1.9-.389A5.443,5.443,0,0,0,14.5,7.925,5.5,5.5,0,0,0,11.051,3.7a5.708,5.708,0,0,0-2.7-.3M.114,8.925c0,2.75,0,3.875.009,2.5s.005-3.625,0-5-.009-.25-.009,2.5M8.4,4.241a4.626,4.626,0,0,0-3.785,3.6,5.628,5.628,0,0,0-.038,1.653,4.649,4.649,0,0,0,.666,1.754l.149.232-.293.868a5.1,5.1,0,0,0-.249.851c.141-.054,1.7-.552,1.728-.552a1.608,1.608,0,0,1,.275.141,5.111,5.111,0,0,0,1.307.5,5.584,5.584,0,0,0,1.846.019,4.64,4.64,0,0,0,3.647-3.568,5.739,5.739,0,0,0,.04-1.641,5.492,5.492,0,0,0-.414-1.322A4.706,4.706,0,0,0,9.817,4.24a5.408,5.408,0,0,0-1.414,0M7.059,6.393a1.453,1.453,0,0,0-.46.554,1.855,1.855,0,0,0,.261,1.785,6.151,6.151,0,0,0,2.159,2.116,7.2,7.2,0,0,0,1.5.489,1.514,1.514,0,0,0,.909-.269.874.874,0,0,0,.45-.73c.04-.261.027-.274-.628-.593a5.061,5.061,0,0,0-.675-.294c-.044,0-.124.065-.2.165a2.074,2.074,0,0,1-.531.537,3.49,3.49,0,0,1-.816-.408,4.038,4.038,0,0,1-1.2-1.325c-.015-.062.018-.125.143-.271A2.03,2.03,0,0,0,8.2,7.817l.07-.143-.232-.561c-.128-.309-.263-.612-.3-.673-.066-.109-.074-.112-.321-.112a.662.662,0,0,0-.358.065",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.38791d553e0165f51813eb0156df2dc0.svg";
export { ForwardRef as ReactComponent };